import { React } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import { BsPencilFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { inPlaceSort } from "fast-sort";
import "./supplierScreen.scss";
import { canManage } from "../../core/utils/permissions";

const SupplierScreen = ({ data, company, user }) => {
  const history = useHistory();
  const isEditable = canManage(user, company);

  inPlaceSort(data).by("name");

  return (
    <div className="client-container supplier-screen">
      <div
        className={`client-body ${
          isEditable ? "default-table-client" : "non-editable"
        }`}
      >
        <GridTable
          columns={columns(isEditable, history)}
          rows={data}
          enableColumnsReorder={false}
          canReorder={false}
          showSearch={true}
          isPaginated={false}
          showColumnVisibilityManager={false}
          showRowsInformation={false}
          texts={{
            noResults: "Nenhum resultado foi encontrado",
            search: "Buscar:",
          }}
        />
      </div>
    </div>
  );
};

export default SupplierScreen;

const openSupplier = (history, id) =>
  history.push(`/suppliers/details/${id}`);

const columns = (isEditable = false, history) => {
  return [
    {
      id: 1,
      field: "name",
      label: "Nome / Razão social",
      width: "1fr",
      resizable: false,
      cellRenderer: ({ data }) => (
        <div
          className="clickable-name"
          onClick={() => openSupplier(history, data.id)}
        >
          {data.name} <br />
          {isMobile ? data.phone : ""}
        </div>
      ),
    },
    !isMobile && {
      id: 2,
      field: "cpf_cnpj",
      label: "CPF / CNPJ",
      width: "1fr",
      resizable: false,
      cellRenderer: ({ data }) => (
        <div
          className="clickable-name"
          onClick={() => openSupplier(history, data.id)}
        >
          {data.cpf_cnpj || "—"}
        </div>
      ),
    },
    !isMobile && {
      id: 3,
      field: "phone",
      label: "Telefone",
      width: "180px",
      resizable: false,
      cellRenderer: ({ data }) => (
        <div
          className="clickable-name"
          onClick={() => openSupplier(history, data.id)}
        >
          {data.phone || "—"}
        </div>
      ),
    },
    isEditable && {
      id: 4,
      field: "actions",
      label: "Ações",
      resizable: false,
      width: "70px",
      cellRenderer: ({ data }) => (
        <ActionCell data={data} history={history} />
      ),
    },
  ].filter((item) => item);
};

const ActionCell = ({ data, history }) => {
  return (
    <div>
      <BsPencilFill
        className="icon-client edit"
        onClick={() => openSupplier(history, data.id)}
      />
    </div>
  );
};
